import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://synxwdzhiiljdirqzmms.supabase.co"; // Supabase projenizin URL'si
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN5bnh3ZHpoaWlsamRpcnF6bW1zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQwOTA4MzEsImV4cCI6MjA0OTY2NjgzMX0.iNZPqt1eArVa-ht7xKG5REg9Bdwmx7hhCcRzpbjZVvE"; // Anonim erişim anahtarı

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
